import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["addButton", "form", "nameInput", "shortCodeInput", "fragileInput", "largeInput", "antiqueInput"]

  showForm() {
    this.toggleFormVisibility(true)
    this.nameInputTarget.focus()
  }

  hideForm() {
    this.toggleFormVisibility(false)
    this.nameInputTarget.value = ""
    this.shortCodeInputTarget.value = ""
    this.fragileInputTarget.checked = false
    this.largeInputTarget.checked = false
    this.antiqueInputTarget.checked = false
  }

  async createItem(event) {
    event.preventDefault()
    const name = this.nameInputTarget.value.trim()
    const shortCode = this.shortCodeInputTarget.value.trim()
    if (!name || !shortCode) {
      const missingInput = name ? this.shortCodeInputTarget : this.nameInputTarget
      missingInput.focus()
      return
    }
    
    this.setFormLoading(true)
    
    try {
      const formData = new FormData()
      formData.append('item_type[name]', name)
      formData.append('item_type[short_code]', shortCode)
      formData.append('item_type[is_fragile]', this.fragileInputTarget.checked)
      formData.append('item_type[is_large]', this.largeInputTarget.checked)
      formData.append('item_type[is_antique]', this.antiqueInputTarget.checked)
      
      const response = await fetch("/admin/item_types", {
        method: "POST",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": this.csrfToken,
          "X-Requested-With": "XMLHttpRequest"
        },
        body: formData
      })

      if (response.ok) {
        const turboStreamHTML = await response.text()
        Turbo.renderStreamMessage(turboStreamHTML)
        this.hideForm()
      } else {
        const errorText = await response.text()
        console.error('Error response:', errorText)
        alert('Error creating item type')
      }
    } catch (error) {
      console.error('Error creating item:', error)
      alert(`Error: ${error.message}`)
    } finally {
      this.setFormLoading(false)
    }
  }

  // ...existing code...

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.hideForm()
    } else if (event.key === "Enter") {
      this.createItem(event)
    }
  }

  // Private helper methods
  toggleFormVisibility(show) {
    this.addButtonTarget.classList.toggle("hidden", show)
    this.formTarget.classList.toggle("hidden", !show)
  }

  setFormLoading(loading) {
    this.formTarget.classList.toggle("opacity-50", loading)
    this.formTarget.classList.toggle("pointer-events-none", loading)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute("content")
  }

  async handleError(response) {
    const responseText = await response.text()
    console.error('Server response:', responseText)
    
    try {
      const { errors } = JSON.parse(responseText)
      alert(`Error: ${errors || 'Could not create item type'}`)
    } catch {
      alert(`Error: Could not create item type (${response.status})`)
    }
  }
}
